import Draggable from 'react-draggable';
import { IModalChartItem } from '../..';
import { Resizable } from 're-resizable';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import DataTableChart from '../DataTableChart';
import classes from './styles.module.scss';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import useDebounce from 'hooks/useDebounce';
import { useState } from 'react';


interface ModalInstanceProps {
  id: number;
  defaultPosition: { x: number; y: number };
  onClose: () => void;
  onChange: () => void;
  chartItem: IModalChartItem;
  changeChartItem: IModalChartItem;
  yearRange: [number, number];
  baseYear: number,
}

const ModalInstance = ({ id, defaultPosition, onClose, chartItem, changeChartItem, yearRange,baseYear, onChange }: ModalInstanceProps) => {
  const [chartKey, setChartKey] = useState<number>(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const onChangeResize = useDebounce(() => {
    setChartKey(prev => prev + 1);
  },500
);

  return (
    <Draggable handle={`#modal-header-${id}`} defaultPosition={defaultPosition}>
      <Resizable
        defaultSize={{ width: `${isMobile?'95%': '600px'}`, height: 'max-content' }}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          background: 'white',
          border: '1px solid #ccc',
          borderRadius: 8,
          boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
          zIndex: 1000 + id,
          overflow: 'hidden',
        }}
        onResizeStop={onChangeResize}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <div id={`modal-header-${id}`} className={classes.modalHeader}>
            {chartItem?.chartData?.revisedData?.changeable === true ? (
              <PrimaryButton
                onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                  event?.stopPropagation();
                  onChange();
                }}
                onTouchStart={(event: React.TouchEvent<HTMLButtonElement>) => {
                  event?.stopPropagation();
                  onChange();
                }}
              >
                Change
              </PrimaryButton>
            ) : null}

            <SecondaryButton
              className={classes.closeButton}
              onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                event?.stopPropagation();
                onClose();
              }}
              onTouchStart={(event: React.TouchEvent<HTMLButtonElement>) => {
                event?.stopPropagation();
                onClose();
              }}
            >
              Close
            </SecondaryButton>
          </div>
          <div className={classes.modalBody}>
            <div className={classes.tableWrapper}>
              <DataTableChart
                key={chartKey}
                title={chartItem?.chartData?.baseCaseData?.name ?? chartItem?.chartData?.revisedData?.name}
                unit={chartItem?.chartData?.baseCaseData?.unit ?? chartItem?.chartData?.revisedData?.unit}
                isPercentage={chartItem?.chartData?.baseCaseData?.isPercentage}
                dataSeries={[chartItem?.chartData?.baseCaseData?.data, chartItem?.chartData?.revisedData?.data]}
                yearRange={yearRange}
                forecastYear={changeChartItem?.chartData?.forecastYear}
                baseYear={baseYear}
              />
            </div>
          </div>
        </Box>
      </Resizable>
    </Draggable>
  );
};

export default ModalInstance;
